import { render } from "./WritingBoard.vue?vue&type=template&id=345a7273&scoped=true&ts=true"
import script from "./WritingBoard.vue?vue&type=script&lang=ts"
export * from "./WritingBoard.vue?vue&type=script&lang=ts"

import "./WritingBoard.vue?vue&type=style&index=0&id=345a7273&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345a7273"]])

export default __exports__